<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{on, attrs}">
      <v-btn color="dialogBtn" dark class="mb-2 red--text text--accent-4" v-bind="attrs" rounded v-on="on">Add new</v-btn>
    </template>
    <v-card>
      <v-toolbar color="secondary" class="mb-2">
        <v-toolbar-title>Add New Allergy</v-toolbar-title>
        <v-btn color="secondary" class="ma-2" @click="showAlert = !showAlert" fab x-small>
          <v-icon>mdi-information-variant</v-icon>
        </v-btn>
      </v-toolbar>
      <v-alert type="info" class="mt-0 mx-2" outlined v-if="showAlert" mode="showAlert" color="primary">
        <v-row>
          <v-col cols="11">Select an allergy from the dropdown below. If you do not find the allergy that concerns you, please leave us a message</v-col>
          <v-col cols="1" class="pr-1" >
            <v-btn fab x-small class="mr-1" @click="showAlert = !showAlert">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-card-text class="mt-5">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-select
            :items="allergies"
            label="Allergies"
            item-text="allergy"
            item-value="id"
            prepend-icon="mdi-bee-flower"
            v-model="allergy"
            :rules="[rules.required]"
            outlined
            rounded
            dense
          ></v-select>
          <v-autocomplete
            v-if="is_medication"
             ref="medications"
            :items="medicationList"
            label="Medications"
            prepend-icon="mdi-prescription"
            item-value="id"
            item-text="medication"
            v-model="medication.medication_id"
            outlined
            dense
            rounded
          >
          </v-autocomplete>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary darken-1" rounded @click="save">Save</v-btn>
        <v-btn color="secondary darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {  mapGetters } from "vuex";
export default {
  data: () => ({
    medicationList:[],
    dialog: false,
    valid: true,
    is_medication: false,
    showAlert: false,
    allergy: '',
    medication: {
      medication_id: ""
    },
    rules: {
      required: v => !!v || 'This field is required'
    }
  }),
  created() {
    this.$store.dispatch("allergies/aList")
    this.$store.dispatch("medications/aList");
  },
  computed: {
    ...mapGetters("allergies", {
      allergies: "gList"
    }),
    ...mapGetters("medications", {
      medications: "gList"
    })
  },
  methods: {
    infoAlert() {
      this.showAlert = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (this.$refs.form.validate()) {
        var value = {allergy_id:this.allergy}
        if (this.allergy == 35) {
          value.medication_id = this.medication.medication_id
        }
        const response = await this.$store.dispatch("allergies/aAdd", value)
        if (response) {
          this.dialog = false;
        }
      }
    }
  },
  watch: {
    allergy(val) {
      if (val == 35) {
        //load medications
        this.is_medication = true
        
      } else {
        this.is_medication = false
      }
    },
    medications(meds) {
      //console.log(meds)
      var list = [];
      meds.forEach(val => {
        var med = val.medication + " (" + val.presentation + ")";
        list.push({id: val.id, medication: med})
      })
      this.medicationList = Object.assign(this.medicationList, list);
      
    } 
  }
};
</script>

<style>
</style>